export default [
  {
    id: '75195966-E757-FD08-7FAA-26DCE6BBB8B2', // id 全局唯一，终身制
    name: 'visualizationCockpitSM',
    path: '/visualization-cockpit-sm',
    meta: { title: '三维驾驶舱' },
    layout: 'fullscreen',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: 'F144BB56-7235-7281-7C8A-8229E4321DAE',
        path: 'index',
        name: 'visualizationCockpitIndexSM',
        component: () => {
          return import('./views/index')
        },
        meta: {
          title: '三维驾驶舱',
        },
      },
    ],
  },

]
